<div class="container-rhestr-nafigeiddio">
  @for (eitem of eitemauDewislen; track eitem) {
    @if (ynCaelMynediad(eitem.mynediad) && ynCaelHawl(eitem.hawl)) {
      <div class="container-teitl-rhestr-nafigeiddio">
        <div class="teitl-eicon-rhestr-nafigeiddio">
          <fa-icon class="eicon-rhestr-nafigeiddio" icon="{{ eitem.eicon }}" size="xs"></fa-icon>
          <div class="teitl-rhestr-nafigeiddio">{{ eitem.teitl | translate }}</div>
        </div>
      </div>

      <mat-nav-list class="rhestr-nafigeiddio">
        @for (plentyn of eitem.plant; track plentyn) {
          @if (ynCaelMynediad(plentyn.mynediad) && ynCaelHawl(plentyn.hawl)) {
            <a mat-list-item [href]="router.serializeUrl(router.createUrlTree([iaithRouterService.cyfieithuLlwybr(plentyn.route)]))" [routerLink]="iaithRouterService.cyfieithuLlwybr(plentyn.route)" [activated]="ynActive(plentyn.route)">
              <div class="container-plentyn">
                <fa-icon class="eicon-plentyn-rhestr-nafigeiddio" icon="{{ plentyn.eicon }}" size="xs"></fa-icon>
                {{ plentyn.teitl | translate }}

                @if (plentyn.route === "/bwletin") {
                  <app-bwletin-newydd></app-bwletin-newydd>
                }
              </div>
            </a>
          }
        }
      </mat-nav-list>
    }
  }
</div>
